module.exports = __webpack_public_path__ + "media/images/athletes/1663-136013044a7d5d9502dbc57818084077.png";